import type { Component } from 'vue'

import { nuxtAppContext, setGlobalConfig } from '@lottocom/frontend-components'

import { NuxtImg, NuxtLinkLocale, NuxtTime } from '#components'

type $I18n = {
  locale: Ref<string>
  t: (key: string, variables?: unknown) => string
}

export default defineNuxtPlugin((nuxtApp) => {
  const { locale, t } = nuxtApp.$i18n as $I18n
  const updateConfig = () =>
    setGlobalConfig({
      general: {
        locale: `${locale.value}-US`,
      },
      lcButton: {
        longPressHint: t('common.button.longpress'),
      },
      lcFlyOut: {
        to: '#teleports',
      },
      lcInfoButton: {
        closeButtonAriaLabel: t('common.modal.close.label'),
        openButtonAriaLabel: t('common.modal.open.label'),
      },
      lcLotteryCutoffTime: {
        textCutoffTime: t('lottery.closingtime.caption.cutofftime'),
        textTimeIsAlmostUp: t('lottery.closingtime.caption.timeisalmostup'),
        textTimeToCutoff: t('lottery.closingtime.caption.timetocutoff'),
      },
      lcModal: {
        to: '#teleports',
      },
      lcPasswordInput: {
        toggleAriaLabel: t('common.input.password.toggle'),
      },
    })
  nuxtApp.vueApp.component('NuxtImg', NuxtImg as Component)
  nuxtApp.vueApp.component('NuxtLink', NuxtLinkLocale)
  nuxtApp.vueApp.component('NuxtTime', NuxtTime)
  nuxtApp.vueApp.provide(nuxtAppContext, {
    useId: () => useId(),
    useState: (init) => useState(init),
  })
  watchImmediate(locale, updateConfig)
})
